<template>
  <v-container fluid class="pa-0">
    <v-card class="mb-4">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('inGame.buffers')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="changeType">{{type === "line" ? 'Bar' : 'Line'}}</v-btn>
      </v-toolbar>
      <v-card-text>
        <v-toolbar class="text-xs-center" v-if="user.role > 2">
          <v-flex xs10>
              <v-slider
              style="padding-top: 60px;"
                v-model.number="weekToReach"
                :min="minWeekToSimulate"
                thumb-label="always"
              ></v-slider>
          </v-flex>
          <v-flex xs2>
            <v-btn @click="simulation">
              Simuler
            </v-btn>
          </v-flex>

        </v-toolbar>
        <v-layout wrap>
          <v-flex :class="{'xs12': bufferCompanies.length > 1, 'xs12' : bufferCompanies.length == 1}" v-for="n in bufferCompanies.length" :key="n" style="max-height: 400px">
            <canvas :id="'chart-buffer' + (n - 1)" width="3000"  height="400"></canvas>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import Chart from 'chart.js';
export default {
  name: "Buffers",
  data() {
    return {
      weekToReach: 0,
      type: "bar",
      charts: [],
      options: {
        hover: {
          mode: 'index',
          intersect: false
        },
        legend: {
          position: "bottom"
        },
        tooltips: {
            mode: 'index',
            intersect: false,
            itemSort: this.labelsSort,
            callbacks: {
              label: this.labelsFormated
            }
        },
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          yAxes: [{
            display: true,
            ticks: {
                beginAtZero: true
            }
          }]
        }
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.bufferCompanies.forEach((company, index) => {
        this.render(company, index);
      })
      let png = []
      setTimeout(async () => {
        for (let index = 0; index < this.bufferCompanies.length; index++) {
          let res = await this.charts[index].toBase64Image();
          png.push(res)
        }
        this.$emit('png', {chart: 'buffers', png: png})
      }, 1000)
    },
    render(company, index) {
      let data = {
        labels: [],
        datasets : []
      }
      data.labels = this.categories(company)
      data.datasets  = this.series(company)

      let options = Object.assign({}, this.options)
      options.title = {
        display: true,
        text: company.name
      }
      // options.scales.yAxes[0].ticks.max = Math.ceil(this.max / 10) * 10
      
      if (!this.charts[index]) {
        this.charts[index] = new Chart(document.querySelector("#chart-buffer" + index), {
          type: this.type,
          options: options,
          data: data
        })
      } else {
        this.charts[index].data = data
        this.charts[index].update({duration: 0})
      }
    },
    categories(company) {
      let categories = [];
      for (let index = 1; index <= company.week; index++) {
        categories.push(this.$t("general.smallWeek") + (index));
        if (new Date(this.game.createdAt) > new Date('4/7/2021')) {
          categories.push(this.$t("general.smallWeek") + (index));
          categories.push(this.$t("general.smallWeek") + (index));
        }
      }
      return categories;
    },
    series(company) {
      let series = []
      
      series.push({
        label: this.$t("inGame.flowEquation"),
        pointRadius: 0,
				pointHoverRadius: 7,
        type: "line",
        lineTension: 0,
        fill: false,
        backgroundColor: '#0000ff',
        borderColor: '#0000ff',
        data: company.data.dd.buffer.flowEquation
      });
      series.push({
        label: this.$t("inGame.stock"),
        pointRadius: 0,
				pointHoverRadius: 7,
        type: "line",
        lineTension: 0,
        fill: false,
        backgroundColor: '#000000',
        borderColor: '#000000',
        data: company.data.dd.buffer.stock
      });
      series.push({
        label: this.$t("inGame.red"),
        pointRadius: 0,
				pointHoverRadius: 7,
        type: this.type,
        lineTension: 0,
        backgroundColor: '#ff0000',
        stack: 'buffer',
        data: company.data.dd.buffer.red
      });
      series.push({
        label: this.$t("inGame.yellow"),
        pointRadius: 0,
				pointHoverRadius: 7,
        type: this.type,
        lineTension: 0,
        backgroundColor: '#ffff00',
        stack: 'buffer',
        data: this.yellowData(company)
      });
      series.push({
        label: this.$t("inGame.green"),
        pointRadius: 0,
				pointHoverRadius: 7,
        type: this.type,
        lineTension: 0,
        backgroundColor: '#008000',
        stack: 'buffer',
        data: this.greenData(company)
      });
      return series;
    },
    async changeType () {
      for (let index = 0; index < this.charts.length; index++) {
        await this.charts[index].destroy()
        this.charts[index] = null
      }

      if (this.type == 'line') {
        this.type = 'bar'
      } else {
        this.type = 'line'
      }
      this.bufferCompanies.forEach((company, index) => {
        this.render(company, index);
      })
    },
    yellowData(company) {
      if (this.type == 'bar') {
        return company.data.dd.buffer.yellow
        } else {
        return company.data.dd.buffer.yellow.map((val, index) => val + company.data.dd.buffer.red[index])
      }
    },
    greenData(company) {
      if (this.type == 'bar') {
        return company.data.dd.buffer.green
        } else {
        return company.data.dd.buffer.green.map((val, index) => val + company.data.dd.buffer.yellow[index] + company.data.dd.buffer.red[index])
      }
    },
    labelsFormated (tooltipItem, data) {
      let label = data.datasets[tooltipItem.datasetIndex].label || '';
      if (label) {
          label += ': ';
      }
      if (tooltipItem.datasetIndex == 3 && this.type == 'bar') {
        label += tooltipItem.yLabel + data.datasets[2].data[tooltipItem.index];
      } else if (tooltipItem.datasetIndex == 4 && this.type == 'bar') {
        label += tooltipItem.yLabel + data.datasets[2].data[tooltipItem.index] + data.datasets[3].data[tooltipItem.index];
      } else {
        label += tooltipItem.yLabel
      }
      return label;
    },
    labelsSort (a, b, data) {
      let aNewValue = a.yLabel
      let bNewValue = b.yLabel
      if (a.datasetIndex == 3 && this.type == 'bar') {
        aNewValue += data.datasets[2].data[a.index];
      } else if (a.datasetIndex == 4 && this.type == 'bar') {
        aNewValue += data.datasets[2].data[a.index] + data.datasets[3].data[a.index];
      }
      if (b.datasetIndex == 3 && this.type == 'bar') {
        bNewValue += data.datasets[2].data[b.index];
      } else if (b.datasetIndex == 4 && this.type == 'bar') {
        bNewValue += data.datasets[2].data[b.index] + data.datasets[3].data[b.index];
      }
      return bNewValue - aNewValue;
    },
    simulation () {
      this.$store.dispatch('games/simulation', {
        id: this.$store.state.games.current._id,
        data: {
          week: this.weekToReach
        } 
      })
    }
  },
  computed: {
    bufferCompanies() {
      return this.$store.getters["games/assignableCompanies"].filter((company) => company.ddOn)
    },
    game() {
      return this.$store.getters["games/current"]
    },
    week() {
      let max = 0;
      this.bufferCompanies.forEach(company => {
        if (company.data.dd.buffer.flowEquation.length > max) {
          max = company.data.dd.buffer.flowEquation.length;
        }
      });
      return max;
    },
    max() {
      let max = 0
      this.bufferCompanies.forEach(company => {
        company.data.dd.buffer.flowEquation.forEach((flowEquation, index) => {
          if (flowEquation > max) {
            max = flowEquation
          }
          if ((company.data.dd.buffer.red[index] + company.data.dd.buffer.yellow[index] + company.data.dd.buffer.green[index]) > max) {
            max = company.data.dd.buffer.red[index] + company.data.dd.buffer.yellow[index] + company.data.dd.buffer.green[index]
          }
        });
      });
      return max;
    },
    minWeekToSimulate() {
      let min = 10000
      this.$store.getters["games/assignableCompanies"].forEach(company => {
        if (company.week < min) {
          min = company.week
        }
      });
      return min !== 10000 ? min : 0;
    },

    ...mapGetters('user', {
      user: 'current'
    })
  },
  sockets: {
    async playerUpdate (data) {
      if (data.company.ddOn && data.company.step == 7) {
        setTimeout(() => {
          this.bufferCompanies.forEach((company, index) => {
            if (company.name == data.company.name) {
              this.render(data.company, index);
            }
          })
        }, 0)
      }
    }
  }
};
</script>
